"use client";

import { cn } from "@/lib/utils";
import React from "react";
import { SpacingType } from "@/types";
import Image from '@/components/ui/Image';
import { Button } from "@/components/ui/button";
import { sectionVariants } from "@/types";
import parse from "html-react-parser";
import { SectionWrapper } from "../components/SectionWraper";

interface Feature1Props {
  darkMode?: boolean;
  variant?: sectionVariants;
  spacing?: SpacingType;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  themeChangeOnScroll?: boolean;
  title?: string;
  featureWithThumbnail?: boolean;
  features?: {
    title?: string;
    subtitle?: string;
    image?: string;
    imageAltText?: string;
    link?: string;
  }[];
  attributes?: React.HTMLProps<HTMLElement>;
}

const Feature1 = ({
  darkMode = false,
  variant = "A",
  spacing,
  usedInPageNav = false,
  pageNavTitle = "Feature 1",
  themeChangeOnScroll = false,
  title,
  featureWithThumbnail = false,
  features,
  attributes,
}: Feature1Props) => {
  const featureClass = cn(
    darkMode ? 'bg-gray-950' : 'bg-white',
  );

  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      themeChangeOnScroll={themeChangeOnScroll}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="feature1"
      attributes={attributes}
    >
      <div className="container">
        <div data-aos="fade-up">
          {title && (
            <h2 className="max-w-2xl mx-auto text-center">
              {parse(title)}
            </h2>
          )}
        </div>

        <div className={`mx-auto mt-10 lg:mt-16 max-w-7xl rounded-2xl border ${featureClass}`} data-aos="fade-up" data-aos-delay="100">
          {features && features.map((feature, index) => (
            <div
              key={index}
              className={`${index !== features.length - 1 ? "border-b" : ""}`}
            >
              <a
                href={feature.link ?? ''}
                tabIndex={-1}
                className="flex flex-col p-6 md:flex-row md:items-center md:justify-between gap-8"
              >
                <div className={cn(
                  "flex flex-col lg:flex-row gap-8 lg:items-center",
                  !featureWithThumbnail && "w-full lg:justify-between"
                )}>
                  <Button variant="outline" size="iconLg" lifted grayBorder className={cn(
                    featureWithThumbnail ? "order-1" : "order-2"
                  )}>
                    <span className="material-symbols-outlined font-variation-filled w-6 h-6" style={{ fontSize: '24px' }}>arrow_forward</span>
                  </Button>
                  <div className={cn(
                    featureWithThumbnail ? "order-2" : "order-1"
                  )}>
                    {feature.title && (
                      <h6>
                        {parse(feature.title)}
                      </h6>
                    )}
                    {feature.subtitle && (
                      <div className="paragraph-md text-muted-foreground">
                        {parse(feature.subtitle)}
                      </div>
                    )}
                  </div>
                </div>

                {featureWithThumbnail && (
                  <div className="flex-shrink-0 md:w-60">
                    {feature.image && (
                      <div className="relative aspect-[240/112] h-full rounded-lg w-full">
                        <Image
                          src={feature.image}
                          alt={feature.imageAltText ?? ''}
                          title={feature.imageAltText ?? ''}
                          className="rounded-lg object-cover"
                          fill
                        />
                      </div>
                    )}
                  </div>
                )}
              </a>
            </div>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
};

export { Feature1 };



